import { COMMUNITY_EXP_TEMP_TITLE_PREFFIX, CUS_EXP_TEMP_TITLE_PREFFIX } from "@/constants";
import { TSafariInfo, TShareData, TVideoBasicInfo } from "@/types";

export const loadScript = (src: string, options?: any): Promise<any> => {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = src;
    if (options) {
      Object.keys(options).forEach(key => {
        script.setAttribute(key, options[key])
      })
    }
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  })
}

 //加载移动端公共脚本
 export const loadMobileCommonScript = (): Promise<any> => {
  if (!myBrowserOS().isMobile) {
    return  Promise.reject();
  }
  if (window["mobileCommon"]) {
    return Promise.resolve();
  } else {
    return loadScript(process.env.REACT_APP_MOBILE_COMMON_SDK!);
  }
}


  // 移动端公共组件库SDK载入完成后执行回调

 export const mobileCommonSdkLoaded = (callback: (sdk: any) => void)=> {
  //如果已载入立即执行
  if (window.mobileCommon) {
    callback && callback(window.mobileCommon);
    return () => {};
  }
  function stop() {
    //移除监听
    window.removeEventListener('mobile_common_sdk_loaded', loadedHandle);
  }
  function loadedHandle() {
    callback && callback(window.mobileCommon);
    stop();
  }
  //创建 SDK载入完成事件监听
  window.addEventListener('mobile_common_sdk_loaded', loadedHandle);
  return stop;
}
export const loadPaymentScript = (): Promise<any> => {
  if (window["Payment"]) {
    return Promise.resolve();
  } else {
    return loadScript(process.env.REACT_APP_PAYMENT_SDK!);
  }
}

export const loadLoginScript = (): Promise<any> => {
  if (window["login"]) {
    return Promise.resolve();
  } else {
    return loadScript(process.env.REACT_APP_SIGN_SDK!);
  }
}

export const scaleImage = (file: File, scale: number = 0.5): Promise<File> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (event: any) => {
      const img = new Image();

      img.onload = function() {
        const canvas = document.createElement('canvas');
        const width = img.width * scale;
        const height = img.height * scale;

        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext('2d');
        try {
          ctx!.drawImage(img, 0, 0, width, height);
          canvas.toBlob((blob) => {
            const scaledFile = new File([blob!], file.name, {
              type: file.type,
              lastModified: Date.now()
            });
            resolve(scaledFile);
          }, file.type);
        } catch (err) {
          reject(err);
        }
      };

      img.onerror = reject;

      img.src = event.target.result;
    };

    reader.onerror = reject;

    reader.readAsDataURL(file);
  });
}

export const selectFile = (options?: any): Promise<File[]> => {
  return new Promise((resolve, reject) => {
    const input = document.createElement("input");
    input.type = "file";
    if (options) {
      Object.keys(options).forEach(key => {
        input.setAttribute(key, options[key]);
      })
    }
    input.style.display = "none";
    document.body.append(input);
    input.onchange = (e: any) => {
      document.body.removeChild(input);
      resolve(e.target.files);
    };
    input.oncancel = reject;
    input.click();
  })
}

export const getFirstFrame = (file: File | string): Promise<Blob> => {
  const { isMobileSafari, isSafari } = getSafariInfo();

  let videoSrc: string;
  if (file instanceof File) {
    videoSrc = URL.createObjectURL(file);
  } else {
    videoSrc = file;
  }

  return new Promise((resolve, reject) => {  
    const videoEle = document.createElement('video');
    videoEle.crossOrigin = "anonymous";

    if (isMobileSafari) {
      videoEle.preload = "auto"
      videoEle.playsInline = true;
      videoEle.autoplay = true;
    }

    videoEle.onloadeddata = async () => {
      if (isSafari) {
        await sleep(200);
        videoEle.pause();
      }

      const width = videoEle.videoWidth;
      const height = videoEle.videoHeight;

      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d') as CanvasRenderingContext2D;
      canvas.width = 200;
      canvas.height = 200 * (height / width);

      videoEle.addEventListener("seeked", () => {
        ctx.drawImage(videoEle, 0, 0, canvas.width, canvas.height);
        canvas.toBlob(
          (blob) => {
            resolve(blob!);
          },
          "image/jpeg",
          0.9,
        );
      });

      videoEle.currentTime = 0;
    }

    videoEle.onerror = err => {
      if (file instanceof File) {
        URL.revokeObjectURL(videoSrc);
      } 
      reject(err);
    };

    videoEle.src = videoSrc;
    videoEle.load();
  });
}

export const getFixedNum = (num: Number, fixed: number = 0) => {
  return parseFloat((num).toFixed(fixed));
}

export const getBasicInfoFromVideo = (video: File | string): Promise<TVideoBasicInfo> => {
  const isFile = video instanceof File;

  return new Promise((resolve, reject) => {
    const videoEle = document.createElement('video');

    videoEle.onloadedmetadata = () => {
      try {
        resolve({
          width: videoEle.videoWidth,
          height: videoEle.videoHeight,
          duration: videoEle.duration,
        });
      } finally {
        if (isFile) {
          URL.revokeObjectURL(videoEle.src);
        }
      }
    }

    videoEle.onerror = err => {
      if (isFile) {
        URL.revokeObjectURL(videoEle.src);
      }
      reject(err);
    };

    videoEle.src = isFile ? URL.createObjectURL(video) : video;
  });
}

export const getFrames = (
  video: File | string,
  containerWidth: number,
  containerHeight: number,
): Promise<string[]> => {
  const { isMobileSafari, isSafari } = getSafariInfo();
  const isFile = video instanceof File;

  return new Promise((resolve, reject) => {
    const frames: string[] = [];

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d') as CanvasRenderingContext2D;

    const videoEle = document.createElement('video');
    if (isMobileSafari) {
      videoEle.preload = "auto"
      videoEle.playsInline = true;
      videoEle.autoplay = true;
    }

    videoEle.onloadeddata = async () => {
      if (isSafari) {
        await sleep(200);

        videoEle.pause();
      }

      const duration = videoEle.duration;
      const width = videoEle.videoWidth;
      const height = videoEle.videoHeight;

      const frameWidth = containerHeight * (width / height);
      const quantity = Math.ceil(containerWidth / frameWidth);
      const interval = duration / quantity;
      const times: number[] = [];
      for (let i = 0; i < quantity; i++) {
        times.push(i * interval);
      }

      canvas.width = frameWidth;
      canvas.height = frameWidth * (height / width);

      videoEle.addEventListener("seeked", () => {
        ctx.drawImage(videoEle, 0, 0, canvas.width, canvas.height);
        canvas.toBlob(
          (blob) => {
            frames.push(blob ? URL.createObjectURL(blob) : "");
            if (times.length > 0) {
              videoEle.currentTime = times.shift() as number;
            } else {
              if (isFile) {
                URL.revokeObjectURL(videoEle.src);
              }
              resolve(frames);
            }
          },
          "image/jpeg",
          1,
        );
      });

      videoEle.currentTime = times.shift() as number;
    }

    videoEle.onerror = (err) => {
      if (isFile) {
        URL.revokeObjectURL(videoEle.src);
      }
      reject(err);
    };

    videoEle.src = isFile ? URL.createObjectURL(video) : video;
    videoEle.load();
  })
}

export const getExtension = (file: File) => {
  let extension = file.name.substring(file.name.lastIndexOf(".") + 1);;
  if (["jfif"].includes(extension.toLowerCase())) {
    return file.type?.split('/')?.[1];
  }
  return extension;
}

export const isLocalUrl = (url: string) => {
  return url.startsWith("blob:");
}

export const getCookie = (name: string) => {
  var value = '; ' + document.cookie;
  var parts = value.split('; ' + name + '=');
  return parts?.pop()?.split(';').shift();
  // if (parts.length === 2) {
  //   return parts.pop().split(";").shift();
  // } else if (name === "locale") {
  //   return "en_US";
  // }
};

export function setCookie(name: string, value: string, expires = 60 * 60 * 24 * 30 * 1000) {
  let hostName = window.document.location.hostname;
  if (!['localhost', '127.0.0.1'].includes(hostName)) {
    hostName = '.fotor.com';
  }
  const exp: any = new Date();
  exp.setTime(exp.getTime() + expires);
  document.cookie =
    name +
    '=' +
    escape(value) +
    ';expires=' +
    exp.toGMTString() +
    ';path=/;domain=' +
    hostName;
}

export const download = (url: string, fileName: string): void => {
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  a.style.display = 'none';
  document.body.appendChild(a);

  a.click();

  document.body.removeChild(a);
}

export const getFileName = (url: string): string => {
  try {
    const urlObj = new URL(url);
    const pathname = urlObj.pathname;
    const segments = pathname.split('/');
    const fileName = segments.pop() || ''; // 获取最后一个段落作为文件名
    return fileName;
  } catch (error) {
    console.error('Invalid URL:', error);
    return '';
  }
}

export const shareToPlatForm = (
  sharePlatform: string,
  shareData: TShareData,
  noTracker?: boolean
): void => {
  const iTop = (window.screen.availHeight - 30 - 450) / 2 //获得窗口的垂直位置;
  const iLeft = (window.screen.availWidth - 10 - 650) / 2
  const newWin: any = window.open(
      'about:blank',
      'Fotor',
      'width=650, height=450, top=' + iTop + ', left=' + iLeft
  )
  const shareUrl = encodeURIComponent(shareData.url)
  // const FBId = process.env.SERVER_ENV === 'production' ? '242107232563837' : '1643947009253606'

  let shareLink = ''
  if (!noTracker) {
      // addSensorPv.sendTracker('fotor_web$click_up$share_website', {
      //     location: window.location.href,
      //     button_position: sharePlatform,
      // })
  }
  switch (sharePlatform) {
      case 'facebook': {
          shareLink = 'https://www.facebook.com/sharer/sharer.php?u=' + shareUrl
          newWin.title = 'Share to Facebook'
          newWin.location.href = shareLink
          break
      }
      case 'twitter': {
          shareLink =
              'https://twitter.com/share?source=' +
              shareUrl +
              '&url=' +
              shareUrl +
              '&text=' +
              encodeURIComponent(shareData.description ?? '')
          newWin.title = 'Share to Twitter'
          newWin.location.href = shareLink
          break
      }
      case 'tumblr': {
          shareLink =
              'https://www.tumblr.com/widgets/share/tool?shareSource=legacy&url=' +
              shareUrl +
              '&posttype=link&title=' +
              encodeURIComponent(shareData.title ?? '') +
              '&content=' +
              shareUrl
          newWin.title = 'Share to Tumblr'
          newWin.location.href = shareLink
          break
      }
      case 'pinterest': {
          shareLink =
              'https://pinterest.com/pin/create/button/?url=' +
              shareUrl +
              '&media=' +
              shareData.thumb +
              '&description=' +
              encodeURIComponent(shareData.description ?? '')
          newWin.title = 'Share to Pinterest'
          newWin.location.href = shareLink
          break
      }
      // case 'facebook': {
      //     shareLink = 'https://www.facebook.com/dialog/send?' + `app_id=${FBId}`
      //     shareLink += '&link=' + shareUrl
      //     shareLink += '&redirect_uri=' + shareUrl
      //     newWin.title = 'Send Facebook Message'
      //     newWin.location.href = shareLink
      //     break
      // }
      case 'linkedin': {
          shareLink = 'https://www.linkedin.com/shareArticle?mini=true&url=' + shareUrl
          newWin.title = 'Share to Linkedin'
          newWin.location.href = shareLink
          break
      }
  }
}

export const isValidImg = (file: File) => {
  const whiteList = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp', 'image/bmp', 'image/tiff'];
  return whiteList.includes(file.type);
}

export const getImgDimensions = (file: File): Promise<{ width: number, height: number }> => {
  return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (event) => {
        const img = new Image();
        img.onload = () => {
          resolve({ width: img.width, height: img.height });
        };
        img.onerror = (error) => {
          reject(error);
        };
        img.src = event.target?.result as string;
      };

      reader.onerror = (error) => {
        reject(error);
      };

      reader.readAsDataURL(file);
  });
}

export const getOffset = (element: HTMLElement, target: HTMLElement) => {
  // 获取元素的边界矩形
  const rect = element.getBoundingClientRect();

  // 获取父元素的父元素的边界矩形
  const grandparentRect = target.getBoundingClientRect();

  // 计算相对于父元素的父元素的边界值
  const offset = {
    top: rect.top - grandparentRect.top,
    left: rect.left - grandparentRect.left,
    bottom: grandparentRect.bottom - rect.bottom,
    right: grandparentRect.right - rect.right
  };

  return offset;
}

export const videoUrl2blobUrl = async (url: string) => {
  try {
    const res = await fetch(url);
    if (res.status !== 200) {
      throw new Error('Request failed');
    }
    const arrayBuffer = await res.arrayBuffer();
    // 兼容 Safari，Safari 无法将非 'video/mp4' 的 Blob 传入 video src
    const blob = new Blob([arrayBuffer], { type: 'video/mp4' });
    // 兼容 Safari
    window.URL = window.URL || window.webkitURL;
    // 将链接地址字符内容转变成 Blob 地址
    const blobUrl = window.URL.createObjectURL(blob);
    return blobUrl;
  } catch (error) {
    throw new Error('Failed to convert URL to Blob');
  }
}

export const decodeUTF8 = (str: any) => {
  return str.replace(/(\\u)(\w{4}|\w{2})/gi, function ($0: any, $1: any, $2: string) {
    return String.fromCharCode(parseInt($2, 16));
  });
}

export const getOldCookie = (name: string) => {
  var strCookie = document.cookie;
  var arrCookie = strCookie.split("; ");
  for (var i = 0; i < arrCookie.length; i++) {
    var arr = arrCookie[i].split("=");
    if (arr[0] === name)
      try {
        return decodeURI(decodeUTF8(arr[1]));
      } catch (e) {
        return decodeUTF8(arr[1]);
      }
  }
  return "";
}

export const getSafariInfo = (): TSafariInfo => {
  const ua = navigator.userAgent.toLowerCase();
  const isSafariBrowser = (ua.indexOf('safari') !== -1 && ua.indexOf('chrome') === -1);
  const isMobile = /iphone|ipod|ipad/.test(ua);
  const isIpadOS = (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1); // For iPadOS
  return {
    isSafari: isSafariBrowser,
    isMobileSafari: isSafariBrowser && isMobile,
    isIpadSafari: isSafariBrowser && isIpadOS,
    isPcSafari: isSafariBrowser && !isMobile && !isIpadOS
  };
}

export const sleep = (timeout: number) => {
  return new Promise((resolve) => {
    setTimeout(resolve, timeout);
  })
}

export const getCurrentFrame = (videoEle: HTMLVideoElement): Promise<string> => {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d') as CanvasRenderingContext2D;
    canvas.width = videoEle.videoWidth;
    canvas.height = videoEle.videoHeight;
    ctx.drawImage(videoEle, 0, 0, canvas.width, canvas.height);
    canvas.toBlob(
      (blob) => {
        if (blob) {
          resolve(URL.createObjectURL(blob));
        } else {
          reject(new Error());
        }
      },
      "image/jpeg",
      1,
    );
  })
}

export const getCommunityExpTempTitle = () => {
  return `${COMMUNITY_EXP_TEMP_TITLE_PREFFIX}${Date.now()}`;
}

export const getCusExpTempTitle = () => {
  return `${CUS_EXP_TEMP_TITLE_PREFFIX}${Date.now()}`;
}

export const myBrowserOS = () => {
  let u = navigator.userAgent;
  let uLower = navigator.userAgent.toLowerCase();
  return {
    //移动终端浏览器版本信息
    ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
    android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1, //android终端或uc浏览器
    iPhone: u.indexOf("iPhone") > -1, //是否为iPhone或者QQHD浏览器
    mac: u.indexOf("Mac") > -1, //是否为iPhone或者QQHD浏览器
    iPad: u.indexOf("iPad") > -1, //是否iPad
    isMobile: /Android|webOS|iPhone|iPod|BlackBerry/i.test(u),
    isSafari: !!uLower.match(/version\/([\d.]+).*safari/),
    isOpera: !!uLower.match(/opera.([\d.]+)/),
    isChrome: !!uLower.match(/chrome\/([\d.]+)/),
    isFirefox: !!uLower.match(/firefox\/([\d.]+)/),
    isEdge: !!uLower.match(/edge\/([\d.]+)/),
    isIE:
      !!uLower.match(/msie ([\d.]+)/) ||
      !!uLower.match(/rv:([\d.]+)\) like gecko/)
  };
}

export const blurImg = (imageUrl: string, blurAmount: number = 20): Promise<string> => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = "Anonymous"; // 如果需要处理跨域图片
    
    // 当图片加载完成时
    image.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      
      if (!ctx) {
        reject('Canvas context creation failed.');
        return;
      }

      // 设置画布的大小与图片一致
      canvas.width = image.width;
      canvas.height = image.height;
      
      // 应用模糊效果
      ctx.filter = `blur(${blurAmount}px)`;

      // 将图片绘制到画布上
      ctx.drawImage(image, 0, 0);

      // 导出处理后的图片为 Data URL
      const blurredImageUrl = canvas.toDataURL('image/png');
      resolve(blurredImageUrl);
    };

    image.onerror = () => {
      reject('Failed to load image.');
    };

    // 设置图片源地址
    image.src = imageUrl;
  });
}

export const isEmpty = (value: any) => {
  if (value === undefined || value === null) {
    return true;
  }
  if (typeof value === "string" && value.trim() === "") {
    return true;
  }
  if (value instanceof Array && value.length === 0) {
    return true;
  }
  if (typeof value === "object" && Object.keys(value).length === 0) {
    return true;
  }
  return false;
}

export function debounce(func: Function, wait: number = 200, immediate?: boolean) {
  let timeout: NodeJS.Timeout | null;

  return function () {
    // @ts-ignore
    let context = this;
    let args = arguments;

    if (timeout) clearTimeout(timeout); // timeout 不为null
    if (immediate) {
      let callNow = !timeout; // 第一次会立即执行，以后只有事件执行后才会再次触发
      timeout = setTimeout(function () {
        timeout = null;
      }, wait)
      if (callNow) {
        func.apply(context, args);
      }
    } else {
      timeout = setTimeout(function () {
        func.apply(context, args);
      }, wait);
    }
  }
}